import React from 'react';

import DoneIcon from '@material-ui/icons/Done';

export default function ConfirmButton(props)
{
  return {
      color : "inherit",
      label : props.name,
      "aria-label" : "契約書の内容を" + props.name,
      icon : <DoneIcon />,
      ...props
  }
}